<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card v-if="scheduleDetails">
          <div class="mb-3 w-100">
            <create-new-special-exam
              :scheduleDetails="scheduleDetails"
              ref="examCreation"
              @getExamQuestions="setExamQuestions"
            ></create-new-special-exam>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  title: "ساخت آزمون برای جلسه",
  mounted() {
    this.getASingleSchedule();
  },
  data() {
    return {
      scheduleDetails: null,
      isLoading: false,
    };
  },
  methods: {
    setExamQuestions(questions) {
      console.log(questions);
    },
    async getASingleSchedule() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASingleScheduleForMaster = new GetASingleScheduleForMaster(
          _this
        );
        getASingleScheduleForMaster.setRequestParam({
          id: _this.$route.params.id,
        });
        await getASingleScheduleForMaster.fetch((response) => {
          if (response.isSuccess) {
            _this.scheduleDetails = response.data;
            console.log(_this.scheduleDetails);
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BOverlay,
    CreateNewSpecialExam,
  },
};
import { BCard, BRow, BCol, BOverlay } from "bootstrap-vue";
import { GetASingleScheduleForMaster } from "@/libs/Api/Schedules";
import CreateNewSpecialExam from "../exams/specialExams/CreateNewSpecialExam.vue";
</script>
<style scoped>
.custom-question-card {
  min-height: 720px;
  max-height: 720px;
  overflow-y: auto;
}
</style>
